import { render } from "./QuickStartNotes.vue?vue&type=template&id=c2e6e7d8&scoped=true&ts=true"
import script from "./QuickStartNotes.vue?vue&type=script&lang=ts"
export * from "./QuickStartNotes.vue?vue&type=script&lang=ts"

import "./QuickStartNotes.vue?vue&type=style&index=0&id=c2e6e7d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e6e7d8"]])

export default __exports__